<template>
    <div class="d-flex " v-if="hasRole(roles.RW_IMOB_CADASTROS) || hasRole(roles.RW_REAL_ESTA_ADMIN)">
    <div class="col-md-3">
        <SearchCardDocument v-on:dataSearch="GetFilter"></SearchCardDocument>
    </div>
    <div class="col-md-9">
        <TableDocuments :key="keyTableDocuments" ref="tableDocuments"></TableDocuments>
        <div class="container-add-button">
            <AddDocumentButton v-on:updateTableDocuments="updateTableDocuments"></AddDocumentButton>
        </div>
    </div>
</div>
</template>

<script>
import DocumentsManagement from '@/views/private/documentsManagement/documentsManagement.js'
export default DocumentsManagement
</script>

<style scoped>
.container-add-button{
    position: fixed;
    bottom: calc(50px - 1vh);
    right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/documentsManagement/documentsManagement.vue